module.exports = __webpack_public_path__ + "img/qilin-stage7.b4e93a81.png";